import {ChangeDetectorRef, Component, ElementRef} from "@angular/core";
import {
    FUIAbstractPop,
    FUIEventsService,
    FUIPopsService,
    FUIResponsiveService,
    PopParentHorizontalAlignment,
    PopParentVerticalAlignment
} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-info-text-pop",
    styleUrls: ["./info-text-pop.component.scss"],
    templateUrl: "./info-text-pop.component.html"
})
export class InfoTextPopComponent extends FUIAbstractPop {
    parentHorizontalAlignment: PopParentHorizontalAlignment = PopParentHorizontalAlignment.RIGHT;
    parentVerticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.BELOW;
    limitWidthToParent: boolean = true;
    adjustHeightToFirstElement: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                popsService: FUIPopsService,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, elementRef, eventsService, popsService, responsiveService);

        this.popped = true;
    }
}
